import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { type ComputedRef, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { flash, modal } from '@/helpers/ui';
import { EmailStatusEnum } from '@/types';

export const useAppointmentOverview = ({
  appointmentsCount,
}: {
  appointmentsCount: ComputedRef<number>;
}) => {
  const customer = inject<any>('customer');
  const { t } = useI18n();

  const showModal = () => {
    if (!customer.value.email) {
      modal('warning', {
        message: t(
          'customers.send_upcoming_appointments_confirmation.no_email',
        ),
      });
    } else if (appointmentsCount.value <= 0) {
      modal('warning', {
        message: t(
          'customers.send_upcoming_appointments_confirmation.no_appointments',
        ),
      });
    } else {
      const subMessage = t(
        'customers.send_upcoming_appointments_confirmation.message',
        { email: customer.value.email, total: appointmentsCount.value },
      );
      modal('confirmation', { subMessage }).then(() => {
        const { mutate, onDone } = useMutation(
          gql`
            mutation sendAppointmentsOverview(
              $input: SendAppointmentsOverviewInput!
            ) {
              sendAppointmentsOverview(input: $input) {
                emailStatus
              }
            }
          `,
          {
            variables: {
              input: {
                email: customer.value.email,
              },
            },
          },
        );
        mutate();
        onDone(
          ({
            data: {
              sendAppointmentsOverview: { emailStatus },
            },
          }) => {
            switch (emailStatus) {
              case EmailStatusEnum.Sent:
                flash(t('global.flash.email_sent'));
                break;
              case EmailStatusEnum.NotSent:
                flash(t('global.flash.email_not_sent'));
                break;
              case EmailStatusEnum.AlreadyRequested:
                flash(t('global.flash.email_already_requested'));
                break;
            }
          },
        );
      });
    }
  };

  return {
    showModal,
  };
};
